module.exports = __webpack_public_path__ + "static/img/zao.c5bf186.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zao.svg
// module id = Smre
// module chunks = 1